// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".required[data-v-c6a4a882]:after{content:\" *\";color:red}.conteudo[data-v-c6a4a882]{height:380px}", ""]);
// Exports
module.exports = exports;
